export default __webpack_public_path__ + "static/media/elalbergue2.02f82f31.jpeg";